import React from "react";

import HillLogoSvg from "../common/logos/HillLogo";

import { useNavigate } from "react-router-dom";

import BgImg from "../common/backgrounds/BgImg";

export default function HomePage({ OnClick }) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(process.env.PUBLIC_URL + "/tutorial");
  };

  return (
    <div className="page">
      <BgImg />

      <div className="UI_Block">
        <HillLogoSvg width={500} height={300} col={"#AF6F4D"} />
        {/* <h2>Welcome to The Hill Group</h2> */}
        <br />
        <h1>Where is Billy the Bear?</h1>

        <h2>Please press the button below to start</h2>
        <br />
        <button className="button" onClick={handleClick}>
          Play Game
        </button>
      </div>
    </div>
  );
}
